/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.customer-survey.service.ts.
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CustomerSurvey} from '../models/customer-survey';
import {CustomerSurveyAnswer} from '../models/customer-survey-answer';
import {CustomerSurveyStat} from '../models/customer-survey-stat';

/**
 * Zweck: Beschreibt class AppCustomerSurveyService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppCustomerSurveyService {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient) {
  }

/**
 * Beschreibt Methode getMine und ihren Rückgabevertrag.
 */
  getMine(): Observable<CustomerSurvey> {
    return this.http.get<CustomerSurvey>(
      '/customer_survey'
    );
  }

/**
 * Beschreibt Methode postpone1 und ihren Rückgabevertrag.
 */
  postpone1(s: CustomerSurvey): Observable<boolean> {
    return this.http.get<boolean>(
      '/customer_survey/' + s.id + '/postpone1'
    );
  }

/**
 * Beschreibt Methode answer und ihren Rückgabevertrag.
 */
  answer(s: CustomerSurvey, a: CustomerSurveyAnswer): Observable<boolean> {
    return this.http.post<boolean>(
      '/customer_survey/' + s.id + '/answer',
      {
        answer: a
      }
    );
  }


/**
 * Beschreibt Methode postpone2 und ihren Rückgabevertrag.
 */
  postpone2(s: CustomerSurvey): Observable<boolean> {
    return this.http.get<boolean>(
      '/customer_survey/' + s.id + '/postpone2'
    );
  }

/**
 * Beschreibt Methode decline und ihren Rückgabevertrag.
 */
  decline(s: CustomerSurvey): Observable<boolean> {
    return this.http.get<boolean>(
      '/customer_survey/' + s.id + '/decline'
    );
  }

/**
 * Beschreibt Methode adminGetAll und ihren Rückgabevertrag.
 */
  adminGetAll(): Observable<CustomerSurvey[]> {
    return this.http.get<CustomerSurvey[]>(
      '/admin/customer_survey'
    );
  }

/**
 * Beschreibt Methode adminGetById und ihren Rückgabevertrag.
 */
  adminGetById(id): Observable<CustomerSurvey> {
    return this.http.get<CustomerSurvey>(
      '/admin/customer_survey/' + id
    );
  }

/**
 * Beschreibt Methode adminGetStatById und ihren Rückgabevertrag.
 */
  adminGetStatById(id): Observable<CustomerSurveyStat> {
    return this.http.get<CustomerSurveyStat>(
      '/admin/customer_survey/' + id + '/stat'
    );
  }

/**
 * Beschreibt Methode adminDeleteById und ihren Rückgabevertrag.
 */
  adminDeleteById(id): Observable<CustomerSurvey> {
    return this.http.get<CustomerSurvey>(
      '/admin/customer_survey/' + id + '/delete'
    );
  }

/**
 * Beschreibt Methode adminSet und ihren Rückgabevertrag.
 */
  adminSet(survey: CustomerSurvey): Observable<CustomerSurvey> {
    return this.http.post<CustomerSurvey>(
      '/admin/customer_survey/' + survey.id,
      {
        survey: survey
      }
    );
  }
}
